import { Component, ReactNode } from 'react';
import styles from '@app/assets/scss/ErrorPage.module.scss';
import Image from 'next/image';
import { MyLink } from '@ui-kit/Link';
import { Button } from '@ui-kit/Button';
import { Section } from '@ui-kit/Section';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  attempt: number;
}

class ErrorBoundaryApp extends Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      hasError: false,
      attempt: 0,
    };
  }

  static getDerivedStateFromError(): Partial<State> {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error('Error caught by ErrorBoundary:', error, errorInfo);

    this.setState(prevState => ({
      attempt: prevState.attempt + 1,
    }));
  }

  render() {
    const { hasError, attempt } = this.state;

    if (hasError) {
      if (attempt < 2) {
        this.setState({ hasError: false });
        return this.props.children;
      }

      return (
        <Section className={styles.Section}>
          <h2 className={styles.Title}>Мы уже работаем над устранением проблемы.</h2>
          <div>
            <Image src="/next/gimg/error_code/500-new.svg" alt="code_error" width={550} height={290} />
          </div>
          <div className={styles.Text__Desktop}>
            Попробуйте обновить страницу через некоторое время либо вернуться на&ensp;
            <MyLink href="/">главную</MyLink>.
          </div>
          <div className={styles.Desc}>Извините за временные неудобства</div>
          <MyLink className={styles.Link} href="/">
            <Button className={styles.Button} themes={'red'}>
              Перейти на главную
            </Button>
          </MyLink>
        </Section>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundaryApp;
